const PlusIcon = ({ size = 12, color = "black" }) => {
    return (
        <svg style={{ height: size, width: size }} viewBox="0 0 12 12" fill="none">
            <rect x="5.625" y="2.25" width="0.75" height="7.5" fill={color} />
            <rect x="9.75" y="5.625" width="0.75" height="7.5" transform="rotate(90 9.75 5.625)" fill={color} />
        </svg>
    );
};

export default PlusIcon;
